import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { ApplicationService } from './services/application.service';
import { AuthenticationService } from './services/authentication.service';
import { ConfigurationService } from './services/configuration.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  constructor(private applicationService:ApplicationService, private configService:ConfigurationService, private authenticationService:AuthenticationService, private router:Router) {}

  async ngOnInit() {
    this.setAuthenticationHeaderBar();
    this.wireSpinnerEvents();
    this.authenticationService.authenticationSubscription.subscribe(action => {
      this.setAuthenticationHeaderBar();
    });

    this.showDevEnvironmentDisclaimer = !this.configService.isProdEnvironment();
  }

  title:string = 'Shot Trak';
  username: string = "";
  isAuthenticated: boolean = false;
  isAdministrator: boolean = false;
  showDevEnvironmentDisclaimer = false;
  isBusy:boolean = false;
  isDropdownOpen = false;

  toggleDropdown(event: Event): void {
    event.stopPropagation(); // prevents click from closing immediately
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector('.dropdown');
    if (dropdown && !dropdown.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  setAuthenticationHeaderBar():void {
    this.isAuthenticated = this.authenticationService.isAuthenticated();
    if(this.isAuthenticated) {
      if(!this.authenticationService.loggedInUser) return;
      this.username = this.authenticationService.loggedInUser.username;
      this.isAdministrator = this.authenticationService.userIsAdministrator();
    }
  }

  logout() {
    this.authenticationService.logout()
    this.authenticationService.publishLogout();
    this.navigate('/login');
  }

  navigate(route:string) {
    this.router.navigate([route]);
  }

  wireSpinnerEvents() {
    this.applicationService.applicationEventSubscription.subscribe(action => {
      if(action === "SHOWGLOBALSPINNER") {
        this.isBusy = true;
      }
      else if(action === "HIDEGLOBALSPINNER") {
        this.isBusy = false;
      }
    });
  }
}